export const locales = {
	en: require('./en.json'),
	id: require('./id.json'),
	kr: require('./kr.json')
}
